'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

var _companyAddForm = require('./company-add-form.component');

var _companyAddForm2 = _interopRequireDefault(_companyAddForm);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _angular2.default.module('components.app.admin.company.company-add-form', []).component('companyAddForm', _companyAddForm2.default).name;


// WEBPACK FOOTER //
// ./components/app/admin/company/company-add-form/company-add-form.module.js